(function () {
  'use strict';
  var endpoint = 'https://hub.labosch.es/api/public/reservations/stock';
  var phone = '34690041276';
  var generation = 0;

  function render(card, own, supplier) {
    if (card.getAttribute('data-lbx-stock-ready') !== 'true' || card.getAttribute('data-lbx-stock-error') === 'true') return;
    var label = card.querySelector('[data-lbx-store-availability]');
    if (!label) return;
    own = Math.max(0, Number(own) || 0);
    supplier = Math.max(0, Number(supplier) || 0);
    var scoped = card.__lbxMatchedVariants || matrix(card);
    var live = card.__lbxLiveStock || {};
    var incoming = scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'incoming'; });
    var assumed = scoped.some(function (variant) { return live[String(variant.id)] && live[String(variant.id)].state === 'assumed'; });
    var arrival = scoped.map(function (variant) { return live[String(variant.id)] && live[String(variant.id)].estimatedArrival; }).filter(Boolean)[0] || '';
    var state = own > 0 ? 'in-stock' : supplier > 0 || assumed ? 'supplier-stock' : incoming ? 'incoming' : 'sold-out';
    label.classList.remove('is-sold-out', 'is-out-of-stock', 'is-available', 'is-supplier', 'is-reservation', 'is-hub-reservation');
    label.classList.add(own > 0 ? 'is-available' : supplier > 0 || assumed ? 'is-supplier' : incoming ? 'is-hub-reservation' : 'is-sold-out');
    var copy = label.querySelector('.lbx109-stock-copy');
    var title = copy && copy.querySelector('b');
    var detail = copy && copy.querySelector('small');
    if (title) title.textContent = state === 'sold-out' ? 'Sin stock' : state === 'incoming' ? 'Disponible bajo reserva' : 'Disponible';
    if (own === 0 && (supplier > 0 || assumed || incoming) && copy) {
      if (!detail) { detail = document.createElement('small'); copy.appendChild(detail); }
      detail.textContent = arrival || (supplier > 0 || assumed ? 'En 10 días laborables' : 'Llegada pendiente de confirmar');
    } else if (detail) detail.remove();
    card.setAttribute('data-lbx-product-stock-status', state);
    card.setAttribute('data-lbx-availability', state);
    card.classList.toggle('is-sold-out', state === 'sold-out');
    updateWhatsapp(card, state === 'sold-out');
  }

  function updateWhatsapp(card, show) {
    var footer = card.querySelector('.lbx-canon-card__footer');
    if (!footer) return;
    var link = footer.querySelector('[data-lbx-ask-availability]');
    if (!show) { if (link) link.remove(); return; }
    if (!link) {
      link = document.createElement('a');
      link.setAttribute('data-lbx-ask-availability', '');
      link.className = 'lbx-ask-availability';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'Preguntar por la disponibilidad';
      footer.appendChild(link);
    }
    var variants = matrix(card);
    var selected = card.__lbxSelectedVariant || (variants.length === 1 ? variants[0] : null);
    var productUrl = (card.querySelector('.lbx-canon-card__title') || {}).href || window.location.href;
    if (!selected) {
      link.textContent = 'Elegir variante para preguntar';
      link.href = productUrl;
      link.removeAttribute('target');
      return;
    }
    link.textContent = 'Preguntar por la disponibilidad';
    link.target = '_blank';
    var detail = Array.isArray(selected.options) ? ' · ' + selected.options.join(' / ') : '';
    var message = 'Hola, quiero preguntar por la disponibilidad de ' + (card.getAttribute('data-lbx-title') || 'esta bicicleta') + detail + ' (variante ' + selected.id + '). ' + productUrl;
    link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }

  function unknown(card) {
    card.__lbxLiveStock = {};
    card.setAttribute('data-lbx-stock-error', 'true');
    card.setAttribute('data-lbx-stock-ready', 'true');
    card.setAttribute('data-lbx-product-stock-status', 'unknown');
    card.setAttribute('data-lbx-availability', 'unknown');
    card.classList.remove('is-sold-out');
    var label = card.querySelector('[data-lbx-store-availability]');
    if (label) {
      label.classList.remove('is-available', 'is-supplier', 'is-sold-out', 'is-reservation', 'is-hub-reservation');
      var copy = label.querySelector('.lbx109-stock-copy');
      if (copy) copy.textContent = 'No se pudo comprobar la disponibilidad';
    }
    updateWhatsapp(card, false);
  }

  function cards() { return Array.from(document.querySelectorAll('[data-lbx-product-card]')); }
  function matrix(card) {
    try { return JSON.parse(card.querySelector('[data-lbx-v103-variants]').textContent).variants || []; }
    catch (_) { return []; }
  }

  async function refresh() {
    var current = ++generation;
    var items = cards();
    var ids = Array.from(new Set(items.flatMap(function (card) { return matrix(card).map(function (variant) { return String(variant.id); }); })));
    var values = {};
    var groups = [];
    for (var start = 0; start < ids.length; start += 30) groups.push(ids.slice(start, start + 30));
    var nextGroup = 0;
    var painted = new Set();
    function paintReadyCards() {
      if (current !== generation) return;
      var changed = false;
      items.forEach(function (card) {
        if (painted.has(card)) return;
        var variants = matrix(card);
        if (!variants.every(function (variant) { return Object.prototype.hasOwnProperty.call(values, String(variant.id)); })) return;
        painted.add(card);
        changed = true;
        var own = 0, supplier = 0, missing = false;
        var live = {};
        variants.forEach(function (variant) {
          var value = values[String(variant.id)];
          if (!value || value.state === 'unknown') { missing = true; return; }
          live[String(variant.id)] = value;
          if (value.state === 'store') own += Number(value.storeStock || 0);
          if (value.state === 'supplier') supplier += Number(value.supplierStock || 0);
        });
        card.__lbxLiveStock = live;
        card.removeAttribute('data-lbx-stock-error');
        card.setAttribute('data-lbx-stock-ready', 'true');
        card.setAttribute('data-lbx-all-own-stock', String(own));
        card.setAttribute('data-lbx-all-supplier-stock', String(supplier));
        card.setAttribute('data-lbx-own-stock', String(own));
        card.setAttribute('data-lbx-supplier-stock', String(supplier));
        if (!variants.length || missing && own <= 0 && supplier <= 0 && !Object.values(live).some(function (value) { return value.state === 'assumed' || value.state === 'incoming'; })) unknown(card);
        else render(card, own, supplier);
      });
      if (changed) document.dispatchEvent(new CustomEvent('lbx:hub-availability'));
    }
    async function worker() {
      while (nextGroup < groups.length) {
        var group = groups[nextGroup++];
        try {
          var response = await fetch(endpoint + '?variantIds=' + encodeURIComponent(group.join(',')), { cache: 'no-store', signal: AbortSignal.timeout(14000) });
          if (!response.ok) throw new Error('stock');
          var data = await response.json();
          if (!data.ok || !data.variants) throw new Error('stock');
          group.forEach(function (id) { values[id] = data.variants[id] || null; });
        } catch (_) {
          group.forEach(function (id) { values[id] = null; });
        }
        paintReadyCards();
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, groups.length) }, worker));
    paintReadyCards();
  }
  window.lbxHubAvailability = { render: render, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
  ['lbx:catalog-updated', 'shopify:section:load'].forEach(function (name) { document.addEventListener(name, refresh); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  window.setInterval(function () { if (!document.hidden) refresh(); }, 30000);
})();
